import { ImportService } from '@amzn/awscat-portfolio-assessment-service-client';
import { Container, Hotspot, RadioGroup, Spinner } from '@amzn/awsui-components-react';
import React, { Component } from 'react';

import { constants } from '../../../common/Localization';
import { HotspotIds } from '../../tutorials/HotspotIds';
import { WIZARD_STEP_VALUES } from './common-util/resources';
import { withWizardContext } from './contexts/WizardContext';
import { WizardContentProps } from './WizardContentProps';

interface State {
    selectedSheet: string;
}

const stepName: WIZARD_STEP_VALUES = WIZARD_STEP_VALUES.SELECT_SHEET;
const importService = new ImportService();
class SelectSheetStep extends Component<WizardContentProps, State> {

    constructor(props: WizardContentProps) {
        super(props);
        this.state = {
            selectedSheet: '',
        };
    }

    componentDidMount() {
        this.props.setNextAndPrevHandlers(stepName, this.next, this.prev);
        this.props.setLoading(false);
    }

    componentDidUpdate() {
        // Initialize radio button to the first option
        if (this.props.sheets.length && this.state.selectedSheet === '') {
            this.setState({
                selectedSheet: this.props.sheets[0].value,
            });
        }
    }

    render() {
        if (this.props.loading) {
            return <Spinner size='large' />;
        }
        return (
            <Container header={
                <Hotspot hotspotId={HotspotIds.SELECT_SHEET_HEADER} side='left' direction='left'>
                    {constants.WIZARD_STEP_LABELS.SELECT_SHEET} 
                </Hotspot>}>
                <RadioGroup value={this.state.selectedSheet} items={this.props.sheets} onChange={this.onRadioChange} />
            </Container>
        );
    }

    onRadioChange = (e: any): void => {
        const selectedSheet: string = e.detail.value;
        this.setState({
            selectedSheet,
        });
    };

    next = async (): Promise<void> => {
        const { portfolioId, importId, type } = this.props.wizardContext;
        const { sheets } = this.props;
        const { selectedSheet } = this.state;
        const parseError: string | undefined = sheets.find(sheet => sheet.value === selectedSheet)?.parseError;
        if (parseError) {
            throw new Error(parseError);
        }
        await importService.postSheetName(portfolioId, importId, this.state.selectedSheet, type);
    };

    prev = async (): Promise<void> => {};
}

export default withWizardContext(SelectSheetStep);
